module.exports = __webpack_public_path__ + "img/IE.03dc0905.svg";